import { Select, Spin } from 'antd';
import React from 'react';

interface LabelValue {
    label: string
    value: number
}
interface Props {
    allowClear?: any
    placeholder?: string
    disabled: boolean
    onSelect: (value: number, option: any) => void;
    onSearchServer: (params: any, options: any) => Promise<any>
}
export default function SelectBox(props: Props) {

    const [keyword, setKeyword] = React.useState<string>("")
    const [datas, setDatas] = React.useState<Array<LabelValue>>([])
    const [fetching, setFetching] = React.useState(false);

    React.useEffect(() => {

        if (!keyword) {
            return;
        }
        const controller = new AbortController();
        const signal = controller.signal
        const delayTimer = setTimeout(() => {
            loadData(keyword, signal)
        }, 300);

        return () => {
            clearTimeout(delayTimer)
            controller.abort();
        }
    }, [keyword])


    const loadData = async (searchText: string, signal: AbortSignal): Promise<any> => {
        setFetching(true);
        const res = await props.onSearchServer({
            searchText: searchText
        }, { signal: signal }).finally(() => {
            setFetching(false);
        })
        setDatas(res)
    }

    return <Select
        // allowClear={props?.allowClear}
        placeholder={props.placeholder}
        showSearch
        dropdownStyle={{
            minWidth: 300
        }}
        filterOption={false}
        onSearch={(inputValue: string) => setKeyword(inputValue)}
        notFoundContent={fetching ? <Spin size="small" /> : null}
        onSelect={props.onSelect}
        disabled={props.disabled}
        options={datas}
    />
}
